"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useSession } from "next-auth/react";
import { isTrainingModeAllowedPath } from "@/lib/training-mode-paths";
import { isTrainingModeRestrictedUser } from "@/lib/training-mode-users";

export default function TrainingModeGate({ children }) {
  const { data: session, status } = useSession();
  const pathname = usePathname();

  const isTrainingMode =
    status === "authenticated" && isTrainingModeRestrictedUser(session?.user);

  useEffect(() => {
    if (!isTrainingMode) return;
    if (isTrainingModeAllowedPath(pathname)) return;
    window.location.replace("/training");
  }, [pathname, isTrainingMode]);

  if (isTrainingMode && !isTrainingModeAllowedPath(pathname)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6">
        <div className="max-w-md text-center">
          <p className="text-sm font-medium text-gray-900">
            Redirecting to your training dashboard...
          </p>
        </div>
      </div>
    );
  }

  return children;
}
